import Navbar from './components/Navbar';
import SearchZone from './components/SearchZone';
import SearchPanal from './components/SearchPanal';

function App() {
  return (
    <div className="App">
        <Navbar />
        <SearchZone />
        <SearchPanal />
    </div>
  );
}

export default App;
